module.exports = __webpack_public_path__ + "img/plan1.683fa56e.png";